// @ts-ignore
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack5'
import styled from 'styled-components'

export const Container = styled.div`
	padding: 1rem 0.5rem;
	background-color: #F3F6F7FF;
	height: calc(100% - 78px);
	overflow-y: auto;
`

export const PDFDocument = styled(Document)`
	display: flex;
	flex-direction: column;
	align-items: stretch;
	text-align: center;
	.pageTitle {
		margin: 23px 0 10px;
		font-size: 0.86em;
	}
	.react-pdf__message {
		padding: 10px 35px;
	}
`

export const PDFPage = styled(Page)`
	overflow: hidden;
	align-self: stretch;
    margin-bottom: 1rem;
`

export const TextContainer = styled.div`
	padding: 10px 35px;
`
